import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class ChildFamilyName extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): ChildFamilyName {
    if (!(value.length > 0)) {
      throw new Error('苗字が入力されていません');
    }
    return new ChildFamilyName(value);
  }

  /** ラベル */
  static get label(): string {
    return '子どもの苗字';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return '山田';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
